export default "/images/regel-2.jpg?b5dcbbe820a685016a254947af54dcc2";